<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="edit-picker-box">
    <el-dialog title="" :visible="true" :before-close="closeBox">
      <div v-if="id == 0">
        <el-form :model="form" label-width="80px">
          <el-form-item label="买手组:">
            <el-input
              v-model="form.pg_name"
              style="width: 50%"
              placeholder="买手组"
            ></el-input>
          </el-form-item>
          <el-form-item label="组长:">
            <el-select
              v-model="form.group_leader"
              filterable
              style="width: 50%"
              placeholder="组长"
            >
              <el-option
                v-for="item in group_leader"
                :key="item.key"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="代号:">
            <el-input
              v-model="form.pg_code"
              style="width: 50%"
              placeholder="代号"
            ></el-input>
          </el-form-item>
          <el-form-item label="市场:">
            <el-select
              v-model="form.market_id"
              filterable
              placeholder="市场"
              style="width: 50%"
            >
              <el-option value="" label="全部"></el-option>
              <el-option
                v-for="item in market"
                :key="item.market_id"
                :value="item.market_id"
                :label="item.market_name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态:">
            <el-select
              v-model="form.status"
              placeholder="状态"
              style="width: 50%"
            >
              <el-option value="" label="全部"></el-option>
              <el-option value="1" label="启用"></el-option>
              <el-option value="0" label="禁用"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button style="width: 25%" @click="closeBox">取消</el-button>
            <el-button type="success" style="width: 25%" @click="submitData"
              >确认</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div v-if="id > 0">
        <el-form :model="form" label-width="80px">
          <el-form-item label="买手组:">
            <el-input
              v-model="form.pg_name"
              style="width: 50%"
              disabled
              placeholder="买手组"
            ></el-input>
          </el-form-item>
          <el-form-item label="组长:">
            <el-select
              v-model="form.group_leader"
              filterable
              style="width: 50%"
              placeholder="组长"
            >
              <el-option
                v-for="item in group_leader"
                :key="item.key"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="代号:">
            <el-input
              v-model="form.pg_code"
              style="width: 50%"
              placeholder="代号"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="市场">
            <el-select
              v-model="form.market_id"
              filterable
              placeholder="市场"
              style="width: 50%"
            >
              <el-option value="" label="全部"></el-option>
              <el-option
                v-for="item in market"
                :key="item.market_id"
                :value="item.market_id"
                :label="item.market_name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态:">
            <el-select
              v-model="form.status"
              placeholder="状态"
              style="width: 50%"
            >
              <el-option value="" label="全部"></el-option>
              <el-option value="1" label="启用"></el-option>
              <el-option value="0" label="禁用"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button style="width: 25%" @click="closeBox">取消</el-button>
            <el-button
              type="success"
              style="width: 25%"
              @click="savesSubmitData"
              >确认</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
    group_leader: [],
  },
  data() {
    return {
      form: {
        group_leader: "",
      },
      market: [],
      fullscreenLoading: false,
    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.fullscreenLoading = true;
      let detailPromise = new Promise((resolve, rejected) => {
        this.$http
          .post("/erp/Common/getFirstMarketList")
          .then((result) => {
            this.fullscreenLoading = false;
            if (result.data.code != 200) {
              return this.$message.error(result.data.msg);
            }
            resolve(result.data.data);
          })
          .catch((err) => {});
      });

      detailPromise.then((res) => {
        this.market = res;
        if (this.id < 1) {
          return false;
        }
        this.$http
          .post("/erp/PickerGroup/getPickerGroupDetail", {
            pg_id: this.id,
          })
          .then((result) => {
            this.fullscreenLoading = false;
            if (result.data.code != 200) {
              return this.$message.error(result.data.msg);
            }
            this.form = result.data.data;
          })
          .catch((err) => {});
      });
    },
    submitData() {
      this.fullscreenLoading = true;
      this.$http
        .post("/erp/PickerGroup/updateOrAddPickerGroup", this.filteredForm)
        .then((result) => {
          this.fullscreenLoading = false;
          if (result.data.code != 200) {
            return this.$message.error(result.data.msg);
          }
          this.$message.success("操作成功");
          this.closeBox();
        })
        .catch((err) => {});
    },
    savesSubmitData() {
      if (this.form.status == 0) {
        this.$confirm("禁用买手组后，所绑定的商家会被自动释放", "提示", {
          closeOnClickModal: false,
          closeOnHashChange: false,
          showCancelButton: false,
        })
          .then(({ value }) => {
            this.submitData();
          })
          .catch((e) => {});
      } else {
        this.submitData();
      }
    },

    closeBox() {
      this.$emit("onCloseDialog", false);
    },
  },
};
</script>

<style scoped>
.bottom-buttom {
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/pages/picker/components/EditPicker.vue